import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";
import { HttpClient, HttpHeaders } from "@angular/common/http";
@Injectable()
export class numberWithCommaService {
    authToken: any;
    user: any;
    constructor(private http: HttpClient) {
    }

    format(original) {
        var originalNumber = parseFloat(original)

        // Skip formatting if it's not a numeric value
        if (!isFinite(originalNumber)) {
            return original
        }

        return this._formatAfterCleanup(originalNumber)
    }

    _formatAfterCleanup(originalNumber) {
        var originalMag
        var negative

        if (originalNumber < 0) {
            originalMag = -1 * originalNumber
            negative = true
        } else {
            originalMag = originalNumber
            negative = false
        }

        var arr = String(originalMag).split('').reverse()
        var start = arr.indexOf('.') + 1                    // start of full part
        var i                                               // source index
        var result = []                                     // array holder of the result

        // copy the fractional part and the decimal if present
        for (i = 0; i < start; i++) {
            result.push(arr[i])
        }

        // main loop
        var c = 0                                           // digit counter
        for (i = start; i < arr.length; i++) {
            result.push(arr[i])
            c++
            if ((c === 3 || c === 5 || c === 7) && (i < arr.length - 1)) {
                result.push(',')
            }
            if (c === 7) {
                c = 0
            }
        }

        if (negative) {
            result.push('-')
        }

        return result.reverse().join('')
    }
}